import { RequestApi } from 'RequestApi';
import printJS from 'print-js';
import { NotificationMessage } from 'components/notification-message/NotificationMessage';

export const Service = {
  userToken: null,
  userLocal: null,
  employee: null,

  // ✅ helper to initialize from localStorage
  init() {
    try {
      const storedUser = localStorage.getItem('employee');
      if (storedUser) {
        this.employee = JSON.parse(storedUser);
      }
    } catch (e) {
      console.error('Failed to parse employee from localStorage:', e);
    }
  },

  // ✅ helper to update both memory + localStorage
  setEmployee(employeeData) {
    this.employee = employeeData;
    try {
      localStorage.setItem('employee', JSON.stringify(employeeData));
    } catch (e) {
      console.error('Failed to save employee to localStorage:', e);
    }
  },
};

Service.init();

export const catchData = async () => {
  let url = '/ui/get-table-cache?';
  url += `auth_token=${Service.userToken}`;

  await RequestApi(url, {})
    .then((res) => {
      if (res.data.status === 'success') {
        const database = JSON.stringify(res.data.database[Service.userLocal.database_name]);
        localStorage.setItem(Service.userLocal.database_name, database);
      } else {
        console.log(res);
      }
    })
    .catch((err) => {
      console.log(`error : ${err}`);
    });
};

export const initializeService = async () => {
  Service.userToken = JSON.parse(localStorage.getItem('authenticated'));
  Service.userLocal = JSON.parse(localStorage.getItem('user'));
};

export const printDocumentPdf = async ({ unid, objectId, layout, letterHead, paperSize }) => {
  let url = '/ui/get-print-document?';
  url += `auth_token=${Service.userToken}`;
  url += `&unid=${unid}`;
  url += `&object_id=${objectId}`;
  url += `&layout=${layout}`;
  url += `&letter_head=${letterHead}`;
  url += `&paper_size=${paperSize}`;
  url += `&database_name=${Service.userLocal.database_name}`;
  await RequestApi(url, {})
    .then((res) => {
      if (res.status === 200) {
        if (res.data.status === 'success') {
          printJS({
            printable: res.data.file,
            type: 'pdf',
          });
        } else {
          NotificationMessage({ message: res.data.msg, status: res.data.status });
        }
      } else {
        NotificationMessage({ message: res.message, status: 'warning' });
      }
    })
    .catch((err) => {
      console.log(`error : ${err}`);
    });
};

export const formatNumberToThreeDecimals = (value) => {
  const cleanedValue = typeof value === 'string' ? value.replace(/,/g, '') : value;
  const num = Number(cleanedValue);
  return Number.isNaN(num) ? '0.000' : num.toFixed(3);
};

export const formatNumberToTwoDecimals = (value) => {
  const cleanedValue = typeof value === 'string' ? value.replace(/,/g, '') : value;
  const num = Number(cleanedValue);
  return Number.isNaN(num) ? '0.00' : num.toFixed(2);
};

export const formatKhmerYear = (year) => {
  const khmerNumbers = ['០', '១', '២', '៣', '៤', '៥', '៦', '៧', '៨', '៩'];
  return String(year)
    .split('')
    .map((digit) => khmerNumbers[Number(digit)])
    .join('');
};

export function getCurrentUser() {
  if (Service.employee) {
    return Service.employee;
  }

  try {
    const storedUser = localStorage.getItem('employee');
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      Service.employee = parsed;
      return parsed;
    }
  } catch (e) {
    console.error('Failed to parse employee:', e);
  }
  return null;
}
